import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import "assets/vendor/nucleo/css/nucleo.css";
import "assets/vendor/@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";

import ClientLayout from "layouts/Client.jsx";
import StripeLayout from "layouts/ClientStripe.jsx";
import AuthLayout from "layouts/Auth.jsx";
import HomeLayout from "layouts/Home.jsx";

import { Provider } from "react-redux";
import configureStore from "store";
const store = configureStore();


ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <Switch>
        <Route path="/client" render={props => <ClientLayout {...props} authState={props.authState} firebaseUser={props.firebaseUser} appToken={props.appToken} />} />
        <Route path="/order" render={props => <StripeLayout {...props} authState={props.authState} firebaseUser={props.firebaseUser} appToken={props.appToken} />} />
        <Route path="/auth" render={props => <AuthLayout {...props} authState={props.authState} firebaseUser={props.firebaseUser} appToken={props.appToken} />} />
        <Route path="/home" render={props => <HomeLayout {...props} authState={props.authState} firebaseUser={props.firebaseUser} appToken={props.appToken} />} />
        <Redirect from="/" to="/home/landing" />
      </Switch>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);
